import { render, staticRenderFns } from "./RightMenuDraft_Ap.vue?vue&type=template&id=ca4b29d2&scoped=true"
import script from "./RightMenuDraft_Ap.vue?vue&type=script&lang=js"
export * from "./RightMenuDraft_Ap.vue?vue&type=script&lang=js"
import style0 from "./RightMenuDraft_Ap.vue?vue&type=style&index=0&id=ca4b29d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4b29d2",
  null
  
)

export default component.exports